import { render, staticRenderFns } from "./productSign.vue?vue&type=template&id=0f3f4c71&scoped=true"
import script from "./productSign.vue?vue&type=script&lang=js"
export * from "./productSign.vue?vue&type=script&lang=js"
import style0 from "./productSign.vue?vue&type=style&index=0&id=0f3f4c71&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3f4c71",
  null
  
)

export default component.exports